import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useSubscriptionItems} from '../hooks/useSubscriptionItems.ts';
import {useParams} from "react-router-dom";

export const ReloadRecordsButton = () => {

    const {id: subscriptionId} = useParams()

    if (!subscriptionId) {
        throw new Error('Product id is required');
    }

    const {fetchRecords} = useSubscriptionItems(subscriptionId);

    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
